<template>
  <div>
    <reward-customer :is-active.sync="isRewarding" @added="rewardAdded" />
    <!-- This needs a further change
	 Currently we are showing all rewards for referrer users and referred users without specifying the difference -->
    <data-table
      title="Customer Reward Transactions"
      :url="url"
      :headers="headers"
      :fields="fields"
      searchable
      @click:row="showDetails"
      @rowClicked="showDetails"
    >
      <template slot="action.icons">
        <v-btn color="primary" @click="isRewarding = true">
          <v-icon color="light-blue lighten-4">
            mdi-plus-outline
          </v-icon>
          Reward Customer
        </v-btn>
      </template>
      <template slot="item.referrer_compensation_status" slot-scope="{ item }">
        <v-icon color="success" v-if="item.referrer_compensation_transaction_done_at">
          mdi-progress-check
        </v-icon>
        <v-icon color="primary" v-else-if="item.referrer_compensation_status === 1">
          mdi-progress-clock
        </v-icon>
        <v-icon color="grey" v-else>
          mdi-progress-alert
        </v-icon>
      </template>
      <template slot="item.referred_compensation_status" slot-scope="{ item }">
        <v-icon color="success" v-if="item.referred_compensation_transaction_done_at">
          mdi-progress-check
        </v-icon>
        <v-icon color="primary" v-else-if="item.referred_compensation_status === 1">
          mdi-progress-clock
        </v-icon>
        <v-icon color="grey" v-else>
          mdi-progress-alert
        </v-icon>
      </template>
    </data-table>
  </div>
</template>

<script>
import RewardCustomer from "./rewardsForm";

export default {
  components: { RewardCustomer },
  data() {
    return {
      isRewarding: false,
      url: "api/v1/transactions/campaignReferralRewards",
      showArchived: false,
      headers: {
        "campaign_name": "Commercial Name",

        "referrer_name": "Referrer Full Name",
        "referrer_compensation": "Referrer Compensation Amount",
        "referrer_compensation_status": "Referrer Compensation Status",

        "referred_name": "Referred Full Name",
        "referred_compensation": "Referred Compensation Amount",
        "referred_compensation_status": "Referred Compensation Status",
      },
      fields: {
        referrer_compensation: {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
        referred_compensation: {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
      },
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  methods: {
    showDetails({ id }) {
      this.$router.push({ name: "customerRewards.show", params: { id } });
    },
    rewardAdded({ message }) {
      this.isRewarding = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
  },
};
</script>
